module.exports = __webpack_public_path__ + "static/media/paint_booth.ca938bc5.jpg";